<template>
  <div class="map-item-filter">
    <div
      class="col-sm-12 nopads vehicle-list"
    >
      <div class="row">
        <div class="col-2 nopads"/>
        <div class="col-8 nopads text-center">
          <span class="vehicle-list-title ml-2">
            {{ $t('map.select_assets') }}
          </span>
        </div>
        <div class="col-2 nopads">
          <div
            class="vehicle-list-caret"
            @click.stop="$emit('close')"
          >
            <font-awesome-icon icon="times-circle" />
          </div>
        </div>
      </div>
        <div class="d-flex flex-wrap justify-content-center px-2 pb-2">
          <button
            v-if="polygonDrawing && showingObservations && enableObservationToGeometry"
            class="btn btn-md btn-primary m-1"
            @click.stop="$emit('observationsToRoadGeometry')"
          >
            <span class="map-button-text">{{ $t('orders.observations_to_geometry') }}</span>
          </button>
          <button
            v-if="polygonDrawing && showEditSelection"
            class="btn btn-md btn-primary m-1"
            @click.stop="$emit('showSelectionSelector')"
          >
            <span class="map-button-text">{{ $t('map.edit_selected_assets') }}</span>
          </button>
          <button
            class="btn btn-info btn-md m-1"
            @click.stop="$emit('clearPolygon')"
          >
            <span class="map-button-text">{{ $t('common.clear') }}</span>
          </button>
      </div>
    </div>
  </div>
</template>

<script>

export default {
    name: 'SelectionTool',
    props: {
        polygonDrawing: Boolean,
        enableObservationToGeometry: {
            type: Boolean,
            default: false
        },
        showingObservations: {
            type: Boolean,
            default: false
        },
        showEditSelection: {
            type: Boolean,
            default: true
        }
    },
    data: function () {
        return {

        }
    },
    mounted: function () {
    },
}
</script>
<style>
</style>
